import React, { useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import IconsBG from '../../common/components/IconsBG';
import Footer from './Footer';
import history from '../../constants/history';
import colors from '../../constants/colors';

export const AuthMessageType = {
  error: 'error',
  information: 'information',
  warning: 'warning',
  email: 'email_verify',
  ip: 'invalid_ip',
  default: 'default',
};

export const ERROR_TYPE_STYLES = {
  [AuthMessageType.error]: 'error',
  [AuthMessageType.information]: 'information',
  [AuthMessageType.warning]: 'warning',
  [AuthMessageType.email]: 'information',
  [AuthMessageType.ip]: 'warning',
  [AuthMessageType.default]: 'warning',
};

const ERROR_HEADER = {
  [AuthMessageType.email]: 'Please verify your email before logging in.',
  [AuthMessageType.ip]: 'Unauthorized IP Address',
  [AuthMessageType.default]: 'Unexpected error',
};
const FULL_ERROR_DETAIL = {
  [AuthMessageType.ip]: '',
  [AuthMessageType.email]:
    'Open your email inbox and look for an email with the subject of Welcome.  Open the email and click on the link in the email to verify your email address.',
  [AuthMessageType.default]:
    'A problem occured during login. Please try again.',
};

const getErrorTypeStyle = (errorType) =>
  ERROR_TYPE_STYLES[errorType] || ERROR_TYPE_STYLES[AuthMessageType.default];

const IconMessage = (error_type) => {
  switch (error_type) {
    case AuthMessageType.email:
    case AuthMessageType.information:
      return 'info';
    case AuthMessageType.warning:
      return 'exclamation';
    case AuthMessageType.ip:
      return 'exclamation';
    default:
      return 'close';
  }
};

const getErrorHeader = (errorType) =>
  ERROR_HEADER[errorType] || ERROR_HEADER[AuthMessageType.default];

// Invalid IP Does not show an error detail
const getFullErrorDetail = (errorType) =>
  !(errorType === AuthMessageType.ip) ? (
    <p>
      {FULL_ERROR_DETAIL[errorType] ||
        FULL_ERROR_DETAIL[AuthMessageType.default]}
    </p>
  ) : null;

const getFullErrorDesc = (errorType, errorDesc) =>
  errorType === AuthMessageType.ip
    ? `IP Address [${errorDesc}] is not authorized`
    : errorDesc;

const AuthCustomMessages = ({ error_type, error_description }) => (
  <div>
    <div className={`square s-${getErrorTypeStyle(error_type)}`}>
      <div>
        <i class={`icon ${IconMessage(error_type)} no-margin`}></i>
      </div>
    </div>
    <div className={`rectangle r-${getErrorTypeStyle(error_type)}`}>
      <p className="relative-position">{getErrorHeader(error_type)}</p>
    </div>
  </div>
);

export const AuthMessages = ({
  error_type = AuthMessageType.warning,
  error_description = '',
  message_only = '',
}) => {
  return (
    <>
      <IconsBG />
      <section
        className="content-container"
        style={{ overflow: 'auto', backgroundColor: colors.NAVY }}
      >
        <header id="top-nav" className={'simple'}>
          <div className={`logo-container`}>
            <div role="presentation" className={'logo'} alt="ErisX" />
          </div>
        </header>
        <div className="onboarding-messages">
          <div className="onboarding-content onboarding-content-message auth-messages">
            <div className="logo"></div>
            <div className="onboarding-content-message-main">
              <AuthCustomMessages
                error_type={error_type}
                error_description={error_description}
              />
              {getFullErrorDetail(error_type)}
              {!message_only && (
                <>
                  <Button
                    className="first-button-recomendation onboarding-content-message-button relative-position"
                    onClick={() => {
                      history.push('/login');
                    }}
                    primary
                    content="Back to Login"
                  />
                  <p className="onboarding-content-message-footer">
                    Having Trouble?{' '}
                    <a
                      href="mailto:clearus.membership@cboe.com"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Contact
                    </a>{' '}
                    our support team
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer></Footer>
      </section>
    </>
  );
};
